import api from "./api";

const baseURL = process.env.REACT_APP_CORE_REGISTRY;

export async function show() {
    return await api.get(`${baseURL}/api/v1/docs`);
}
export async function get(filename) {
    return await api.get(`${baseURL}/api/v1/docs/${filename}`);
}
